const DropdownIcon = ({ rotate }: { rotate?: number }) => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      transform: `rotate(${rotate || 0}deg)`
    }}
  >
    <path
      d="M5 12.7129L10 7.71289L15 12.7129"
      stroke="#98A2B3"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default DropdownIcon;
